import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Construction } from "lucide-react";
import { useLocation } from "react-router-dom";
import { EmptyState } from "./EmptyState";
export function ComingSoonRoute({ title = "Not yet implemented" }) {
    const { pathname } = useLocation();
    return (_jsx(EmptyState, { icon: Construction, iconLabel: "Construction", title: title, body: _jsxs(_Fragment, { children: ["The route ", _jsx("code", { children: pathname }), " is on the roadmap but not yet wired up. Pick another item from the sidebar."] }) }));
}
//# sourceMappingURL=ComingSoonRoute.js.map